import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import productService from '../services/productService';
import ProductCard from './common/ProductCard';
import QuickViewModal from './common/QuickViewModal';

const BestSellingProductsGrid = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // Quick View modal state
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showQuickView, setShowQuickView] = useState(false);

    useEffect(() => {
        const fetchBestSellingProducts = async () => {
            setLoading(true);
            try {
                const response = await productService.getBestSellingProducts(8);
                if (response && response.succeeded) {
                    setProducts(response.products || []);
                } else {
                    console.error('En çok satan ürünler yüklenirken hata:', response);
                    setError('En çok satan ürünler yüklenirken bir hata oluştu.');
                }
            } catch (err) {
                console.error('En çok satan ürünler yüklenemedi:', err);
                setError('En çok satan ürünler yüklenirken bir hata oluştu.');
            } finally {
                setLoading(false);
            }
        };

        fetchBestSellingProducts();
    }, []);

    // Quick View handlers
    const handleQuickView = (product) => {
        setSelectedProduct(product);
        setShowQuickView(true);
    };

    const handleCloseQuickView = () => {
        setShowQuickView(false);
        setSelectedProduct(null);
    };

    if (loading) {
        return (
            <section className="best-selling-products py-80">
                <div className="container container-lg">
                    <div className="text-center mb-48">
                        <h2 className="mb-12">En Çok Satanlar</h2>
                        <p className="text-neutral-600">Müşterilerimizin en çok tercih ettiği ürünler</p>
                    </div>
                    <div className="text-center py-5">
                        <div className="spinner-border text-main-600" role="status">
                            <span className="visually-hidden">Yükleniyor...</span>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (error) {
        return (
            <section className="best-selling-products py-80">
                <div className="container container-lg">
                    <div className="text-center mb-48">
                        <h2 className="mb-12">En Çok Satanlar</h2>
                        <p className="text-neutral-600">Müşterilerimizin en çok tercih ettiği ürünler</p>
                    </div>
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                </div>
            </section>
        );
    }

    if (!products || products.length === 0) {
        return null;
    }

    return (
        <>
            <section className="best-selling-products py-60 bg-gradient-to-br from-neutral-50 to-main-50">
                <div className="container container-lg">
                    <div className="section-heading text-center mb-48">
                        <h2 className="mb-12" style={{ fontSize: 'clamp(24px, 5vw, 32px)' }}>En Çok Satanlar</h2>
                        <p className="text-neutral-600 mb-0" style={{ fontSize: 'clamp(14px, 3vw, 16px)' }}>
                            Müşterilerimizin en çok tercih ettiği ürünler
                        </p>
                    </div>

                    {/* 4x2 Grid - Responsive */}
                    <div className="row gy-4 g-12">
                        {products.slice(0, 8).map(product => (
                            <div key={product.id} className="col-xxl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                                <ProductCard 
                                    product={product} 
                                    viewMode="grid"
                                    showQuickView={true}
                                    compact={false}
                                    onQuickView={handleQuickView}
                                />
                            </div>
                        ))}
                    </div>

                    {/* View All Button */}
                    <div className="text-center mt-48">
                        <Link 
                            to="/shop" 
                            className="btn btn-main rounded-pill py-16 px-32 text-white fw-semibold transition-2 hover-bg-main-800 shadow-lg"
                            style={{ 
                                backgroundColor: '#299E60',
                                border: 'none',
                                fontSize: 'clamp(14px, 3vw, 16px)'
                            }}
                        >
                            Tüm Ürünleri Gör
                            <i className="ph ph-arrow-right ms-8"></i>
                        </Link>
                    </div>
                </div>

                {/* Quick View Modal */}
                <QuickViewModal
                    product={selectedProduct}
                    isOpen={showQuickView}
                    onClose={handleCloseQuickView}
                />
            </section>
        </>
    );
};

export default BestSellingProductsGrid;
